export default "__VITE_ASSET__e91e298a__"